import { isFreeWorkspacePlan } from '@/lib/free-workspace-experience';

type CreditStatus = 'healthy' | 'low' | 'critical' | 'insufficient';

export function isCriticalLowCreditStatus(args: {
  billingPlan: string | null | undefined;
  creditStatus: CreditStatus | null | undefined;
}): boolean {
  if (!args.billingPlan || isFreeWorkspacePlan(args.billingPlan)) return false;
  return (
    args.creditStatus === 'critical' || args.creditStatus === 'insufficient'
  );
}

export function shouldShowLowCreditsPopup(args: {
  billingPlan: string | null | undefined;
  creditStatus: CreditStatus | null | undefined;
  isDismissed: boolean;
}): boolean {
  return (
    !args.isDismissed &&
    isCriticalLowCreditStatus({
      billingPlan: args.billingPlan,
      creditStatus: args.creditStatus,
    })
  );
}
